import * as Api from '@ViewModels';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { useConnectionTypes } from '../../../../queries/ConnectionType/useConnectionTypes';

export function useAutomationConnectionTypes(impersonationContext?: Api.IImpersonationContext) {
	const userSession = useUserSession();

	const connectionTypesEnabled =
		impersonationContext?.account?.features?.connectionTypes?.enabled ??
		userSession.account.features.connectionTypes?.enabled ??
		false;

	const connectionTypesQuery = useConnectionTypes({
		enabled: connectionTypesEnabled,
		impersonationContext,
		refetchOnWindowFocus: false,
	});

	return {
		connectionTypes: connectionTypesQuery.data?.availableConnectionTypes ?? [],
		isLoadingConnectionTypes: connectionTypesQuery.isLoading,
	};
}
